import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataService } from '../data/data.service';
import { SideBar, SideBarMenu } from '../models/models';

@Injectable({
  providedIn: 'root',
})
export class SideBarService {
  public toggleSideBar: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem('isMiniSidebar') || 'false'
  );

  public toggleMobileSideBar: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem('isMobileSidebar') || 'false'
  );

  public expandSideBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private data: DataService) {}

  // public switchSideMenuPosition(): void {
  //   if (localStorage.getItem('isMiniSidebar')) {
  //     this.toggleSideBar.next('false');
  //     localStorage.removeItem('isMiniSidebar');
  //     this.data.sideBar.map((mainMenus: SideBar) => {
  //       mainMenus.menu.map((resMenu: SideBarMenu) => {
  //         const menuValue = sessionStorage.getItem('menuValue');
  //         if (menuValue && menuValue === resMenu.menuValue) {
  //           resMenu.showSubRoute = true;
  //         }
  //       });
  //     });
  //   } else {
  //     this.toggleSideBar.next('true');
  //     localStorage.setItem('isMiniSidebar', 'true');
  //     this.data.sideBar.map((mainMenus: SideBar) => {
  //       mainMenus.menu.map((resMenu: SideBarMenu) => {
  //         resMenu.showSubRoute = false;
  //       });
  //     });
  //   }
  // }

  public switchMobileSideBarPosition(): void {
    if (localStorage.getItem('isMobileSidebar')) {
      this.toggleMobileSideBar.next('false');
      localStorage.removeItem('isMobileSidebar');
    } else {
      this.toggleMobileSideBar.next('true');
      localStorage.setItem('isMobileSidebar', 'true');
    }
  }
}
